import React from 'react'

import { Document } from '../../../api/documents/types'
import Loading from '../layout/Loading'
import Grid from '../layout/Grid'
import NoResults from '../layout/NoResults'
import DocumentCard from './DocumentCard'

type Props = {
  data: Document[] | null | undefined
  isLoading: boolean
  error: Error | null
  xsCols?: number
  smCols?: number
  mdCols?: number
  lgCols?: number
}
const DocumentGrid: React.FC<Props> = ({ data, isLoading, error, ...rest }) => {
  if(isLoading) return <Loading size='fill-container' />
  if(error) return <div>{error.message}</div>
  if(!data || data.length === 0) return <NoResults />
  return (
    <Grid {...rest}>
      {data?.map((document) => (
        <DocumentCard
          id={document.id}
          key={document.title}
          title={document.title}
          authors={document.authors}
          type={document.type}
          difficulty={document.difficultyLevel.name}
          category={document.mainCategory.name}
          bookmarked={document?.userActivity?.saved}
        />
      ))}
    </Grid>
  )
}

export default DocumentGrid
